import { render, staticRenderFns } from "./Sjdt.vue?vue&type=template&id=55a12c07&scoped=true"
import script from "./Sjdt.vue?vue&type=script&lang=js"
export * from "./Sjdt.vue?vue&type=script&lang=js"
import style0 from "./Sjdt.vue?vue&type=style&index=0&id=55a12c07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a12c07",
  null
  
)

export default component.exports